import { Search, Calendar, CreditCard, Sparkles } from "lucide-react";
const steps = [
  {
    icon: Search,
    title: "Discover",
    description: "Search for wellness services, spas, or practitioners near you using our smart filters and map.",
    number: "01",
  },
  {
    icon: Calendar,
    title: "Book",
    description: "View real-time availability and book your preferred time slot instantly. No phone calls needed.",
    number: "02",
  },
  {
    icon: CreditCard,
    title: "Pay Securely",
    description: "Pay directly to the wellness business.",
    number: "03",
  },
  {
    icon: Sparkles,
    title: "Enjoy",
    description: "Arrive relaxed and enjoy your wellness experience. Leave a review to help others.",
    number: "04",
  },
];
export function HowItWorks() {
  return (
    <section className="py-20 bg-background" aria-labelledby="how-it-works-heading">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 id="how-it-works-heading" className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">
            How to Book Wellness Services Online
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Book your next spa treatment, massage therapy, yoga class, or fitness session in just a few clicks
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div
              key={step.title}
              className="relative group animate-fade-up"
              style={{
                animationDelay: `${index * 0.15}s`,
              }}
            >
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-[60%] w-[80%] h-[2px] bg-gradient-to-r from-primary/30 to-primary/10" />
              )}

              <div className="text-center">
                {/* Number badge */}
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 text-6xl font-display font-bold text-primary/10 group-hover:text-primary/20 transition-colors">
                  {step.number}
                </div>

                {/* Icon */}
                <div className="relative inline-flex items-center justify-center w-20 h-20 rounded-2xl gradient-primary shadow-wellness-md group-hover:shadow-wellness-glow mb-6 transition-all duration-300">
                  <step.icon className="w-9 h-9 text-primary-foreground" />
                </div>

                {/* Content */}
                <h3 className="font-display text-xl font-semibold text-foreground mb-3">{step.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
